import { IUser } from "./tenant-transformer";

export interface IUserGroupData {
  id: string;
  name: string;
  users: IUser[];
}

export function transformToBackendUserGroup(data: IUserGroupData) {
  return {
    id: data.id,
    name: data.name,
    users: data.users
  };
}

export function transformFromBackendUserGroup(backendType: IUserGroupData) {
  return {
    ...backendType,
    users: backendType.users.map((user: IUser) => {
      return {
        ...user,
      };
    }),
  };
}
